import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-accordion-tab',
    templateUrl: './accordion-tab.component.html',
    styleUrls: ['./accordion-tab.component.scss']
})
export class AccordionTabComponent implements OnInit {
    @Input() styleClass: string;
    @Input() iconClass: string;

    @Input() tabTitle: string;
    @Input() opened = false;
    @Input() completed = false;
    @Input() hide: boolean; // true if tab should be rendered even if not visible (map!!!)
    @Input() tooltip: string;
    @Input() tooltipType: string;
    @Input() disabled: boolean;
    @Output() toggle: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit(): void {
        this.hide = this.hide || false;
        this.disabled = this.disabled || false;
    }

    onToggle() {
        if (!this.disabled) {
            this.toggle.emit();
        }
    }
}
